import { render, staticRenderFns } from "./submission_list.vue?vue&type=template&id=59c55b93&scoped=true&"
import script from "./submission_list.vue?vue&type=script&lang=ts&"
export * from "./submission_list.vue?vue&type=script&lang=ts&"
import style0 from "./submission_list.vue?vue&type=style&index=0&id=59c55b93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c55b93",
  null
  
)

export default component.exports